/**
 * Parallel Clinic, sidebar tab landing.
 *
 * Path: /_authenticated/parallel-clinic
 * Renders the ParallelClinicPage (list of intakes + new-intake form +
 * abandon affordance). No role gate.
 */
import { createFileRoute } from '@tanstack/react-router';
import { ParallelClinicPage } from '../../pages/ParallelClinic/ParallelClinicPage';

export const Route = createFileRoute('/_authenticated/parallel-clinic')({
  component: ParallelClinicPage,
});
